import { render, staticRenderFns } from "./pending-table.vue?vue&type=template&id=f70c37ca&scoped=true&"
import script from "./pending-table.vue?vue&type=script&lang=js&"
export * from "./pending-table.vue?vue&type=script&lang=js&"
import style0 from "./pending-table.vue?vue&type=style&index=0&id=f70c37ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c37ca",
  null
  
)

export default component.exports